import { dateUtils } from "../utils/DateUtils";
import { AbstractEntityService } from "./AbstractEntityService";

export class PaymentService extends AbstractEntityService {
    constructor(baseUrl) {
        super();
        this.baseUrl = baseUrl;
    }

    paymentsCollectionUrl(propertyId) {
        return `${this.baseUrl}/properties/${propertyId}/payments`;
    }

    orderPaymentsUrl(propertyId, orderId) {
        return `${this.baseUrl}/properties/${propertyId}/orders/${orderId}/payments`;
    }

    /**
     * Loads payments. When orderId is set, uses the order-scoped USER endpoint.
     * Without orderId, uses the manager property-wide payments endpoint.
     */
    async findAll(propertyId, orderId) {
        const url = orderId != null && orderId !== ''
            ? this.orderPaymentsUrl(propertyId, orderId)
            : this.paymentsCollectionUrl(propertyId);

        try {
            const payments = await super.find(url);
            payments.forEach((payment) => dateUtils.parseTimestampsToDates(payment));
            return payments;
        } catch (error) {
            this.handleError(error, "Unable to load Payments - please see server logs for more details");
        }
    }

    async create(propertyId, payment) {
        const orderId = payment?.orderId;
        const url = orderId
            ? this.orderPaymentsUrl(propertyId, orderId)
            : this.paymentsCollectionUrl(propertyId);

        try {
            return await super.create(url, payment);
        } catch (error) {
            this.handleError(error, "Unable to create Payment - please see server logs for more details");
        }
    }

    async update(propertyId, payment) {
        const orderId = payment?.orderId;
        const url = orderId
            ? `${this.orderPaymentsUrl(propertyId, orderId)}/${payment.id}`
            : `${this.paymentsCollectionUrl(propertyId)}/${payment.id}`;

        try {
            return await super.update(url, payment);
        } catch (error) {
            this.handleError(error, `Unable to update Payment - please see server logs for more details`);
        }
    }

    async delete(propertyId, paymentId) {
        const url = `${this.paymentsCollectionUrl(propertyId)}/${paymentId}`;

        try {
            return await super.delete(url);
        } catch (error) {
            this.handleError(error, `Unable to delete Payment - please see server logs for more details`);
        }
    }
}
